import { Process } from '../models/process-models';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { isNull } from 'util';

export class ProcessValidationHelper {
    private static readonly generalProcessHeadNotification = 'General Info problems';
    private static readonly processFateFormat = 'YYYY-MM-DD';
    private static readonly dateComparisonFactor = 'day';

    static isProcessValid(process: Process, toastr: ToastrService) {
        if (!this.isValidProcessGeneralInfo(process, toastr)) {
            return false;
        }
        return true;
    }

    private static isValidProcessGeneralInfo(process: Process, toastr: ToastrService) {
        let isValid = true;
        if (process.name.some(name => name.name.length === 0)) {
            isValid = false;
            this.callToastr('Some of localized names are empty', toastr);
        }
        if (this.parseDate(process.firstDuration.startDate).isBefore(this.convertToMoment(new Date()), this.dateComparisonFactor)) {
            isValid = false;
            this.callToastr('Launch date is less than Today date', toastr);
        }
        if (this.parseDate(process.firstDuration.endDate).isBefore(process.firstDuration.startDate, this.dateComparisonFactor)) {
            isValid = false;
            this.callToastr(`Launch date is greater than Expiration date`, toastr);
        }
        if (process.surveyId == null) {
            isValid = false;
            this.callToastr(`Survey hasn't been chosen`, toastr);
        }
        return isValid;
    }

    private static callToastr(body: string, toastr: ToastrService) {
        if (isNull(toastr)) {
            return;
        }
        toastr.error(body, this.generalProcessHeadNotification);
    }

    private static parseDate(date: string) {
        return moment(date, this.processFateFormat);
    }

    private static convertToMoment(date: Date) {
        return moment(date).format(this.processFateFormat);
    }
}